import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Request from './infrastructures/request'


Vue.config.productionTip = false
Vue.prototype.$req = Request;

import loading from './components/plug/loading/index' // 引入loading
Vue.use(loading) // 全局使用loading


//layer
import  {layer}  from './components/plug/layer/index' 
Vue.use(layer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
